import { createEntityQuery } from "@datorama/akita";
import { ISnackbarState, snackbarStore } from "./snackbar.store";

const sq = createEntityQuery<ISnackbarState>(snackbarStore);

export const snackbars$ = sq.select(state => state.snackbars);

export const snackbarQuery = {
    snackbars$,
};